import { render, staticRenderFns } from "./ModifierRadioGroup.vue?vue&type=template&id=5aa702d1&"
import script from "./ModifierRadioGroup.vue?vue&type=script&lang=js&"
export * from "./ModifierRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports